jQuery(function($) {
	var ids = ["#fornavn", 
			"#etternavn", 
			"#epost", 
			"#adresse", 
			"#by", 
			"#land", 
			"#rolle", 
			"#orklaAnnualReport", 
			"#generalFormCollectionDocuments",
			"#selskap",
			"#postnummer"
		];
	ids.forEach(function(inputValue) {
		$(inputValue).keyup(function() {
			var value = $(this).val();
			$(inputValue+"Value").text(value);
		});
	});
	$('.validateButton').on('click', function(e) {
		if($('#annual-report-form')[0].checkValidity()) {
			$($(this).data('target')).addClass('active')
				.siblings().removeClass('active');
			if($('#bestillerSom1').prop("checked")) {
				$('#bestillerSomValue').text("Privatperson");
			} else {
				$('#bestillerSomValue').text("Selskap");
			}
			$('#rolleValue').text("" + $('#rolle option:selected').text());
		} else {
			const tmpSubmit = document.createElement('button');
			tmpSubmit.className = "d-none";
		    $('#annual-report-form').append(tmpSubmit);
		    tmpSubmit.click();
		    $('#annual-report-form').remove(tmpSubmit);
		}
	});
	$('.page-toggler').on('click', function(e) {
		e.preventDefault();
		$($(this).data('target')).addClass('active')
			.siblings().removeClass('active');
	});
	$('.btn-group-toggle .btn').on("click", function() {
		$(this).children('input').prop('checked', true);
	});
	$('.company-toggle').on('click', function(e) {
		$('.selskap-wrapper').show();
		$('#selskap').prop('required',true);
	});
	$('.person-toggle').on('click', function() {
		$('.selskap-wrapper').hide();
		$('#selskap').prop('required',false);
	});
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/annual-report.js
// module id = 26
// module chunks = 0